import {Component, Inject, OnInit, Optional} from '@angular/core';
import {APP_DIALOG_DATA, DialogService} from '../../../core/services/dialog.service';
import {OfficialTeam, TeamStatus} from '../../../core/model/resources/team';
import {AuthService} from "../../../core/services/auth.service";

@Component({
    selector: 'app-team-selecter',
    templateUrl: './team-selecter.component.html',
    styleUrls: ['./team-selecter.component.scss'],
    standalone: false
})
export class TeamSelecterComponent implements OnInit {

  constructor(@Inject(APP_DIALOG_DATA) @Optional() readonly data: { teams: OfficialTeam[], showClose: boolean },
              private authService: AuthService,
              private dialogService: DialogService) {
  }

  ngOnInit(): void {
  }

  getAuthName(team: OfficialTeam): string {
    return this.authService.isContractor(team) ? '契約者' :
      this.authService.isAdministrator(team) ? '管理者' : 'アンバサダー';
  }

  getStatusLabelClass(team: OfficialTeam) {
    switch (team.status) {
      case TeamStatus.suspended:
        return 'suspended';
      case TeamStatus.disbanded:
        return 'disbanded';
      case TeamStatus.draft:
        return 'draft';
      default:
        return '';
    }
  }

  close(team: OfficialTeam): void {
    this.dialogService.hide(team, true);
  }

  cancel() {
    this.dialogService.hide(null, true);
  }


}
